import { Condition } from "@/utils/condition/condition";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";

export class SaleLayoutConf {
	ID:number = 0;
	Name:string = "";
	ContactGroupID:number = 1;
	Data:SaleLayout = new SaleLayout();
	Conditions:Condition[] = [];

	constructor(data?:any) {
		if (!data) {
			return;
		}
		this.ID = data.ID;
		this.Name = data.Name;
		this.ContactGroupID = data.ContactGroupID;
		this.Data = new SaleLayout(data.Data);
		this.Conditions = (data.Conditions || []).map((c:any)=>new Condition(c));
	}

	getJSON() {
		return {
			ID: this.ID,
			Name: this.Name,
			ContactGroupID: this.ContactGroupID,
			Data: this.Data.getJSON(),
			Conditions: this.Conditions.map(c=>c.getJSON())
		};
	}
}

